import React from 'react';
import cx from 'clsx';

import styles from '@danske/sapphire-css/components/skeleton/skeleton.module.css';

import {
  SapphireStyleProps,
  useSapphireStyleProps,
  useThemeCheck,
} from '../../utils';
import { useDimensions } from './useDimensions';
import { getAnimationDelay } from './animation';
import { SkeletonProps } from './skeleton.model';

export interface SkeletonFromProps extends SkeletonProps, SapphireStyleProps {
  /** Content which properties would be inferred by skeleton */
  children: React.ReactElement;
}

export const SkeletonFrom: React.FC<SkeletonFromProps> = ({
  index,
  children,
  ...rest
}) => {
  useThemeCheck();

  const { Content, dimensions } = useDimensions(children);
  const { styleProps } = useSapphireStyleProps(rest);

  const animationDelay = getAnimationDelay(index);

  return (
    <div
      {...rest}
      style={{
        animationDelay,
        ...dimensions,
        ...styleProps.style,
      }}
      className={cx(styles['sapphire-skeleton'], styleProps.className)}
    >
      <Content />
    </div>
  );
};
